module.exports = __webpack_public_path__ + "img/泡沫轴大腿前侧滚动左.92f50d70.png";